import * as carrier from 'src/api/carriers'
import {
  GET_ALL_CARRIERS,
  GET_ALL_CARRIERS_ZH_COD
} from 'src/store/mutation-types'

const getAllCarriers = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  carrier.getAllCarriers(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CARRIERS, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CARRIERS, [])
    }
  })
}

const getAllCarrierZhCod = ({commit, dispatch}, params) => {
  dispatch('toggleLoadding', true, {root: true})
  carrier.getAllCarrierZhCod(params).then(response => {
    if (response.code === 200) {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CARRIERS_ZH_COD, response.data)
    } else {
      dispatch('toggleLoadding', false, {root: true})
      commit(GET_ALL_CARRIERS_ZH_COD, [])
    }
  })
}

export default {
  getAllCarriers,
  getAllCarrierZhCod
}



// WEBPACK FOOTER //
// ./src/components/carrier/store/actions.js